export const formatTime = (seconds) => {
  if (!Number.isFinite(seconds) || seconds < 0) return "0:00";
  const whole = Math.floor(seconds);
  return `${Math.floor(whole / 60)}:${String(whole % 60).padStart(2, "0")}`;
};

export const formatSize = (bytes) => `${(bytes / (1024 * 1024)).toFixed(1)} MB`;

const NOTE_NAMES = ["C", "Db", "D", "Eb", "E", "F", "Gb", "G", "Ab", "A", "Bb", "B"];
const NOTE_INDEX = { C: 0, "C#": 1, Db: 1, D: 2, "D#": 3, Eb: 3, E: 4, F: 5,
  "F#": 6, Gb: 6, G: 7, "G#": 8, Ab: 8, A: 9, "A#": 10, Bb: 10, B: 11 };

export const transposeKey = (key, semitones) => {
  const match = /^([A-G](?:#|b)?)\s+(Major|Minor)$/i.exec(key || "");
  if (!match) return null;
  const index = NOTE_INDEX[match[1]];
  if (index === undefined) return null;
  return `${NOTE_NAMES[((index + semitones) % 12 + 12) % 12]} ${match[2]}`;
};

export const apiErrorMessage = (error, fallback) => {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "object" && typeof detail?.message === "string") return detail.message;
  if (error?.code === "ERR_NETWORK") return "Sin conexión con el servidor. Inténtalo de nuevo.";
  return fallback;
};
